import type { PlanData } from '@/types'
import { DateTime } from 'luxon'

export const formatLastUpdated = (timeString?: string | null) => {
	if (!timeString) {
		return ''
	}

	return DateTime.fromISO(timeString).toFormat('MM/dd/yyyy @ h:mm a')
}

export const getPlanFullName = (plan: Partial<PlanData>) => {
	return `${plan.firstName ?? ''} ${plan.lastName ?? ''}`.trim()
}

/**
 * Can be used to convert Slot content to the raw text
 * @param vnodes
 */
export const vnodesToText = (vnodes: any): string => {
	if (!vnodes) return ''
	const arr = Array.isArray(vnodes) ? vnodes : [vnodes]

	return arr
		.map((v) => {
			if (!v) return ''
			if (typeof v === 'string') {
				return v
			}

			// Plain text node
			if (v.type === Text) {
				return String(v.children ?? '')
			}

			// Element / component with children
			const ch = v.children

			if (typeof ch === 'string') {
				return ch
			}
			if (Array.isArray(ch)) return vnodesToText(ch)

			return ''
		})
		.join('')
}
